export default "__VITE_ASSET__8312b599__"